import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";

import { useFilterContext } from "../FilterContext";

const FilterItemLastSeenTime = () => {
  const { filterData, setFilterData, filterOptions, filterOptionsCount } = useFilterContext();
  return (
    <RadioGroup
      aria-labelledby="demo-controlled-radio-buttons-group"
      name="controlled-radio-buttons-group"
      value={filterData.lastSeenTime}
      onChange={(e) => {
        setFilterData({
          lastSeenTime: e.target.value,
        });
      }}
    >
      {filterOptions.lastSeenRangeTime.map((item, index) => (
        <FormControlLabel
          key={index}
          value={item.value}
          control={<Radio />}
          label={
            <Typography color="textPrimary">
              {`${item.label} (${
                filterOptionsCount["lastSeenTime"][item.value]?.progress.toLocaleString() ?? 0
              }/${filterOptionsCount["lastSeenTime"][item.value]?.total.toLocaleString() ?? 0})`}
            </Typography>
          }
        />
      ))}
    </RadioGroup>
  );
};

export default FilterItemLastSeenTime;
